// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Retheme'd against Untitled UI tokens (react-app/src/sass/untitled/tokens),
   per assets/handoffs/design_handoff_event_engagement. Widget chrome (card,
   header/subheader, tabs, badges, empty state) is the shared Untitled
   components — see index.js, EventRow.js, EmptyState.js. What's left here is
   markup with no Untitled equivalent: the data table (row-expand + inline
   mini bars aren't supported by theme/untitled/Table), the footer legend,
   the "View all" tertiary-brand link, and the loading skeleton. */

.eew-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

/* Card band structure (see FIXES.md #1): header, toolbar, thead and footer
   are each a full-width band with their own 1px rule — Card.Body is
   \`noPadding\` and every band below owns its own 24px horizontal padding
   instead of bleeding out of a padded body. */
.eew-toolbar {
  padding: 16px 24px;
  border-bottom: 1px solid var(--border-secondary);
}

/* "View all" tertiary-brand link (Card.Header action). No Button hierarchy
   matches this brand-coloured tertiary treatment, so it's styled locally —
   see assets/handoffs/design_handoff_event_engagement README, Card shell. */
.eew-view-all {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 12px;
  border-radius: var(--radius-md);
  background: transparent;
  font-size: var(--text-sm-size);
  font-weight: 600;
  color: var(--color-brand-700);
  text-decoration: none;
}

.eew-view-all:hover {
  background: var(--color-brand-50);
  text-decoration: none;
}

.eew-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.eew-col-event {
  width: auto;
}

.eew-col-metric {
  width: 128px;
}

.eew-col-when {
  width: 104px;
}

.eew-col-chevron {
  width: 48px;
}

/* White, not gray — the band rule under it is the separator; a gray fill on
   top of the rule would be a second boundary in the same place. */
.eew-table thead th {
  padding: 12px 16px;
  background: var(--bg-primary);
  font-size: var(--text-xs-size);
  line-height: var(--text-xs-line);
  font-weight: 500;
  color: var(--text-tertiary);
  text-align: left;
  border-bottom: 1px solid var(--border-secondary);
  white-space: nowrap;
}

.eew-table thead th.text-right {
  text-align: right;
}

.eew-table th:first-child,
.eew-table td:first-child {
  padding-left: 24px;
}

.eew-table th:last-child,
.eew-table td:last-child {
  padding-right: 16px;
}

/* Rows */
.eew-data-row {
  cursor: pointer;
}

.eew-data-row:hover td,
.eew-data-row--expanded td {
  background: var(--bg-secondary);
}

.eew-data-row td {
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-secondary);
  font-size: var(--text-sm-size);
  color: var(--text-tertiary);
  vertical-align: middle;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.eew-data-row td.text-right {
  text-align: right;
}

.eew-table tbody tr:last-child td {
  border-bottom: 0;
}

/* Event cell */
.eew-event-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.eew-event-name {
  font-weight: 500;
  font-size: var(--text-sm-size);
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.eew-event-meta {
  font-size: var(--text-xs-size);
  line-height: var(--text-xs-line);
  color: var(--text-tertiary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Metric cell (Impressions / Views) */
.eew-metric {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.eew-metric-track {
  width: 52px;
  height: 6px;
  border-radius: var(--radius-full);
  background: var(--bg-tertiary);
  overflow: hidden;
  flex: none;
}

.eew-metric-fill {
  height: 100%;
  border-radius: var(--radius-full);
}

.eew-metric-fill--imp {
  background: var(--bg-brand-solid);
}

.eew-metric-fill--views {
  background: var(--color-success-500);
}

.eew-metric-value {
  font-size: var(--text-sm-size);
  font-weight: 500;
  color: var(--text-primary);
  min-width: 18px;
  text-align: right;
}

.eew-metric-value--zero {
  color: var(--text-quaternary);
  font-weight: 400;
}

/* Days to go (plain, non-warning case) */
.eew-dtg {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  font-size: var(--text-sm-size);
  font-weight: 500;
  color: var(--text-primary);
}

.eew-dtg-unit {
  font-size: var(--text-xs-size);
  font-weight: 400;
  color: var(--text-tertiary);
}

/* "Today" (daysToGo === 0) — filled, not soft, so it stands out from the
   1-3 day warning badge. warning-700 (not -500/-600) is the deliberate fill:
   those fail WCAG AA for white text at 12px. Type+class selector to outrank
   Badge.module.scss's color classes regardless of CSS import order. */
span.eew-badge-today {
  background: var(--color-warning-700);
  color: #ffffff;
  border-color: var(--color-warning-700);
  font-weight: 600;
}

/* View rate, when undefined (0 impressions) */
.eew-ratio-empty {
  font-size: var(--text-sm-size);
  color: var(--text-quaternary);
}

/* Expand button */
.eew-expand-btn {
  display: inline-flex;
  padding: 6px;
  border: 0;
  background: transparent;
  border-radius: var(--radius-sm);
  cursor: pointer;
  color: var(--fg-quaternary);
  opacity: 0;
  transition: opacity 0.15s ease-out, transform 0.15s ease-out,
    background-color 0.15s ease-out, color 0.15s ease-out;
}

.eew-data-row:hover .eew-expand-btn,
.eew-data-row:focus-within .eew-expand-btn,
.eew-data-row--expanded .eew-expand-btn {
  opacity: 1;
}

.eew-data-row--expanded .eew-expand-btn {
  transform: rotate(90deg);
  color: var(--text-tertiary);
}

.eew-expand-btn:hover {
  background: var(--bg-tertiary);
  color: var(--text-tertiary);
}

.eew-expand-btn:focus-visible {
  outline: none;
  opacity: 1;
  box-shadow: var(--focus-ring-gray);
}

/* Expand row */
.eew-expand-row td {
  padding: 0 24px 16px;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-secondary);
}

.eew-expand-inner {
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.eew-expand-label {
  font-size: var(--text-xs-size);
  line-height: var(--text-xs-line);
  font-weight: 500;
  color: var(--text-tertiary);
  margin-bottom: 8px;
}

.eew-source-grid {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.eew-source-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: var(--bg-primary);
  border: 1px solid var(--border-secondary);
  border-radius: var(--radius-md);
}

.eew-source-dot {
  width: 8px;
  height: 8px;
  border-radius: var(--radius-full);
  flex-shrink: 0;
  display: inline-block;
}

.eew-source-label {
  font-size: var(--text-xs-size);
  color: var(--text-secondary);
}

.eew-source-count {
  font-size: var(--text-sm-size);
  font-weight: 600;
  color: var(--text-primary);
}

/* Footer */
.eew-footer {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  padding: 12px 24px;
  border-top: 1px solid var(--border-secondary);
  font-size: var(--text-xs-size);
  line-height: var(--text-xs-line);
  color: var(--text-tertiary);
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.eew-footer-legend {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
}

.eew-footer-legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.eew-legend-dot {
  width: 8px;
  height: 8px;
  border-radius: var(--radius-full);
  flex-shrink: 0;
  display: inline-block;
}

.eew-legend-dot--imp {
  background: var(--bg-brand-solid);
}

.eew-legend-dot--views {
  background: var(--color-success-500);
}

/* Loading skeleton. Card.Body is noPadding (see band structure note above),
   so this owns its own padding to match the toolbar/table/footer rhythm. */
.eew-shimmer-table {
  display: flex;
  flex-direction: column;
  padding: 16px 24px 20px;
}

.eew-shimmer-thead,
.eew-shimmer-row {
  display: flex;
  gap: 8px;
  padding: 12px 8px;
}

.eew-shimmer-thead {
  padding-top: 0;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-secondary);
  margin-bottom: 4px;
}

.eew-scol-a {
  flex: 0 0 36%;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.eew-scol-b,
.eew-scol-c,
.eew-scol-d {
  flex: 0 0 16%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.eew-skel {
  background: var(--color-gray-100);
  border-radius: 4px;
  border-radius: var(--radius-xs, 4px);
}

.eew-skel-h {
  height: 14px;
  width: 100%;
}

.eew-skel-h-sm {
  height: 10px;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/apps/admin/pages/DashboardPage/EventEngagementWidget/EventEngagementWidget.css"],"names":[],"mappings":"AAAA;;;;;;kEAMkE;;AAElE;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;8CAG8C;AAC9C;EACE,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;;4EAE4E;AAC5E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;kEACkE;AAClE;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,eAAe;AACjB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;EAChD,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;EACtB,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iCAAiC;EACjC,8BAA8B;EAC9B,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;;sEAGsE;AACtE;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,2BAA2B;EAC3B,UAAU;EACV;yDACuD;AACzD;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,UAAU;EACV,kCAAkC;AACpC;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,gDAAgD;AAClD;;AAEA;EACE,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,6CAA6C;EAC7C,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;EAC3B,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;2EAC2E;AAC3E;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;EAGE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,iCAAiC;EACjC,kBAAoC;EAApC,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb","sourcesContent":["/* Retheme'd against Untitled UI tokens (react-app/src/sass/untitled/tokens),\n   per assets/handoffs/design_handoff_event_engagement. Widget chrome (card,\n   header/subheader, tabs, badges, empty state) is the shared Untitled\n   components — see index.js, EventRow.js, EmptyState.js. What's left here is\n   markup with no Untitled equivalent: the data table (row-expand + inline\n   mini bars aren't supported by theme/untitled/Table), the footer legend,\n   the \"View all\" tertiary-brand link, and the loading skeleton. */\n\n.eew-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  white-space: nowrap;\n}\n\n/* Card band structure (see FIXES.md #1): header, toolbar, thead and footer\n   are each a full-width band with their own 1px rule — Card.Body is\n   `noPadding` and every band below owns its own 24px horizontal padding\n   instead of bleeding out of a padded body. */\n.eew-toolbar {\n  padding: 16px 24px;\n  border-bottom: 1px solid var(--border-secondary);\n}\n\n/* \"View all\" tertiary-brand link (Card.Header action). No Button hierarchy\n   matches this brand-coloured tertiary treatment, so it's styled locally —\n   see assets/handoffs/design_handoff_event_engagement README, Card shell. */\n.eew-view-all {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 12px;\n  border-radius: var(--radius-md);\n  background: transparent;\n  font-size: var(--text-sm-size);\n  font-weight: 600;\n  color: var(--color-brand-700);\n  text-decoration: none;\n}\n\n.eew-view-all:hover {\n  background: var(--color-brand-50);\n  text-decoration: none;\n}\n\n.eew-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.eew-col-event {\n  width: auto;\n}\n\n.eew-col-metric {\n  width: 128px;\n}\n\n.eew-col-when {\n  width: 104px;\n}\n\n.eew-col-chevron {\n  width: 48px;\n}\n\n/* White, not gray — the band rule under it is the separator; a gray fill on\n   top of the rule would be a second boundary in the same place. */\n.eew-table thead th {\n  padding: 12px 16px;\n  background: var(--bg-primary);\n  font-size: var(--text-xs-size);\n  line-height: var(--text-xs-line);\n  font-weight: 500;\n  color: var(--text-tertiary);\n  text-align: left;\n  border-bottom: 1px solid var(--border-secondary);\n  white-space: nowrap;\n}\n\n.eew-table thead th.text-right {\n  text-align: right;\n}\n\n.eew-table th:first-child,\n.eew-table td:first-child {\n  padding-left: 24px;\n}\n\n.eew-table th:last-child,\n.eew-table td:last-child {\n  padding-right: 16px;\n}\n\n/* Rows */\n.eew-data-row {\n  cursor: pointer;\n}\n\n.eew-data-row:hover td,\n.eew-data-row--expanded td {\n  background: var(--bg-secondary);\n}\n\n.eew-data-row td {\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-secondary);\n  font-size: var(--text-sm-size);\n  color: var(--text-tertiary);\n  vertical-align: middle;\n  font-variant-numeric: tabular-nums;\n}\n\n.eew-data-row td.text-right {\n  text-align: right;\n}\n\n.eew-table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n/* Event cell */\n.eew-event-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.eew-event-name {\n  font-weight: 500;\n  font-size: var(--text-sm-size);\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.eew-event-meta {\n  font-size: var(--text-xs-size);\n  line-height: var(--text-xs-line);\n  color: var(--text-tertiary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Metric cell (Impressions / Views) */\n.eew-metric {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.eew-metric-track {\n  width: 52px;\n  height: 6px;\n  border-radius: var(--radius-full);\n  background: var(--bg-tertiary);\n  overflow: hidden;\n  flex: none;\n}\n\n.eew-metric-fill {\n  height: 100%;\n  border-radius: var(--radius-full);\n}\n\n.eew-metric-fill--imp {\n  background: var(--bg-brand-solid);\n}\n\n.eew-metric-fill--views {\n  background: var(--color-success-500);\n}\n\n.eew-metric-value {\n  font-size: var(--text-sm-size);\n  font-weight: 500;\n  color: var(--text-primary);\n  min-width: 18px;\n  text-align: right;\n}\n\n.eew-metric-value--zero {\n  color: var(--text-quaternary);\n  font-weight: 400;\n}\n\n/* Days to go (plain, non-warning case) */\n.eew-dtg {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 4px;\n  font-size: var(--text-sm-size);\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.eew-dtg-unit {\n  font-size: var(--text-xs-size);\n  font-weight: 400;\n  color: var(--text-tertiary);\n}\n\n/* \"Today\" (daysToGo === 0) — filled, not soft, so it stands out from the\n   1-3 day warning badge. warning-700 (not -500/-600) is the deliberate fill:\n   those fail WCAG AA for white text at 12px. Type+class selector to outrank\n   Badge.module.scss's color classes regardless of CSS import order. */\nspan.eew-badge-today {\n  background: var(--color-warning-700);\n  color: #ffffff;\n  border-color: var(--color-warning-700);\n  font-weight: 600;\n}\n\n/* View rate, when undefined (0 impressions) */\n.eew-ratio-empty {\n  font-size: var(--text-sm-size);\n  color: var(--text-quaternary);\n}\n\n/* Expand button */\n.eew-expand-btn {\n  display: inline-flex;\n  padding: 6px;\n  border: 0;\n  background: transparent;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  color: var(--fg-quaternary);\n  opacity: 0;\n  transition: opacity 0.15s ease-out, transform 0.15s ease-out,\n    background-color 0.15s ease-out, color 0.15s ease-out;\n}\n\n.eew-data-row:hover .eew-expand-btn,\n.eew-data-row:focus-within .eew-expand-btn,\n.eew-data-row--expanded .eew-expand-btn {\n  opacity: 1;\n}\n\n.eew-data-row--expanded .eew-expand-btn {\n  transform: rotate(90deg);\n  color: var(--text-tertiary);\n}\n\n.eew-expand-btn:hover {\n  background: var(--bg-tertiary);\n  color: var(--text-tertiary);\n}\n\n.eew-expand-btn:focus-visible {\n  outline: none;\n  opacity: 1;\n  box-shadow: var(--focus-ring-gray);\n}\n\n/* Expand row */\n.eew-expand-row td {\n  padding: 0 24px 16px;\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border-secondary);\n}\n\n.eew-expand-inner {\n  font-variant-numeric: tabular-nums;\n}\n\n.eew-expand-label {\n  font-size: var(--text-xs-size);\n  line-height: var(--text-xs-line);\n  font-weight: 500;\n  color: var(--text-tertiary);\n  margin-bottom: 8px;\n}\n\n.eew-source-grid {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.eew-source-chip {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-secondary);\n  border-radius: var(--radius-md);\n}\n\n.eew-source-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: var(--radius-full);\n  flex-shrink: 0;\n  display: inline-block;\n}\n\n.eew-source-label {\n  font-size: var(--text-xs-size);\n  color: var(--text-secondary);\n}\n\n.eew-source-count {\n  font-size: var(--text-sm-size);\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n/* Footer */\n.eew-footer {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding: 12px 24px;\n  border-top: 1px solid var(--border-secondary);\n  font-size: var(--text-xs-size);\n  line-height: var(--text-xs-line);\n  color: var(--text-tertiary);\n  font-variant-numeric: tabular-nums;\n}\n\n.eew-footer-legend {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-left: auto;\n}\n\n.eew-footer-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.eew-legend-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: var(--radius-full);\n  flex-shrink: 0;\n  display: inline-block;\n}\n\n.eew-legend-dot--imp {\n  background: var(--bg-brand-solid);\n}\n\n.eew-legend-dot--views {\n  background: var(--color-success-500);\n}\n\n/* Loading skeleton. Card.Body is noPadding (see band structure note above),\n   so this owns its own padding to match the toolbar/table/footer rhythm. */\n.eew-shimmer-table {\n  display: flex;\n  flex-direction: column;\n  padding: 16px 24px 20px;\n}\n\n.eew-shimmer-thead,\n.eew-shimmer-row {\n  display: flex;\n  gap: 8px;\n  padding: 12px 8px;\n}\n\n.eew-shimmer-thead {\n  padding-top: 0;\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--border-secondary);\n  margin-bottom: 4px;\n}\n\n.eew-scol-a {\n  flex: 0 0 36%;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.eew-scol-b,\n.eew-scol-c,\n.eew-scol-d {\n  flex: 0 0 16%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 6px;\n}\n\n.eew-skel {\n  background: var(--color-gray-100);\n  border-radius: var(--radius-xs, 4px);\n}\n\n.eew-skel-h {\n  height: 14px;\n  width: 100%;\n}\n\n.eew-skel-h-sm {\n  height: 10px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
